import { useState } from 'react';
import { weeklyUpdate } from '@/mocks/comics';

export default function WeeklySection() {
  const [active, setActive] = useState(weeklyUpdate[0].day);

  const current = weeklyUpdate.find((d) => d.day === active) || weeklyUpdate[0];

  return (
    <section id="weekly" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mb-8 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="text-xs font-medium tracking-wide text-primary-600">WEEKLY</span>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">本周更新</h2>
          <p className="mt-1 text-sm text-foreground-600">周一至周日，追更进度一目了然</p>
        </div>
      </div>

      {/* Day tabs */}
      <div className="mb-6 flex flex-wrap gap-2 rounded-full bg-background-100 p-1 md:inline-flex">
        {weeklyUpdate.map((d) => (
          <button
            key={d.day}
            type="button"
            onClick={() => setActive(d.day)}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
              active === d.day ? 'bg-primary-500 font-medium text-white' : 'text-foreground-700 hover:text-primary-600'
            }`}
          >
            {d.day}
          </button>
        ))}
      </div>

      {/* Day list */}
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="flex items-center justify-between border-b border-background-200 bg-background-100 px-5 py-3">
          <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
            <i className="ri-calendar-event-line text-primary-500"></i>
            {active}更新
          </h3>
          <span className="whitespace-nowrap text-xs text-foreground-500">{current.items.length} 部作品更新</span>
        </div>
        <ul className="divide-y divide-background-100">
          {current.items.map((it, i) => (
            <li key={`${it.title}-${i}`} className="flex flex-col gap-2 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-center gap-3">
                <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-secondary-100 text-sm font-medium text-secondary-900">
                  {i + 1}
                </span>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{it.title}</p>
                  <p className="text-xs text-foreground-500">{it.genre}</p>
                </div>
              </div>
              <div className="flex items-center gap-2 pl-11 sm:pl-0">
                <span className="whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-800">{it.chapter}</span>
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-time-line"></i>今日
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}